/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { DeliveryOption } from '@msdyn365-commerce/retail-proxy';

/**
 * DeliveryOptionsCartLineAddress Class.
 */
export class DeliveryOptionsCartLineAddress {
    public cartLineIds?: string[];
    public deliveryOptions: DeliveryOption[];
    public hasError: boolean;
    public error?: string;

    public constructor(deliveryOptions: DeliveryOption[], hasError: boolean, error?: string, cartLineIds?: string[]) {
        this.cartLineIds = cartLineIds;
        this.deliveryOptions = deliveryOptions;
        this.hasError = hasError;
        this.error = error;
    }
}
